export default __webpack_public_path__ + "static/media/qr_04.cc67efe0.jpg";